import { Component, OnInit } from '@angular/core';
import { ComponentBase } from 'src/app/main/dynamic/component-base';
import { AttributeModel } from 'src/app/main/dynamic/model/attribute.model';

@Component({
  selector: 'app-input-currency',
  templateUrl: './input-currency.component.html',
  styleUrls: ['./input-currency.component.scss']
})
export class InputCurrencyComponent extends ComponentBase implements OnInit {

  constructor() { super() }

  ngOnInit() {
    if (this.attribute.value == "")
      this.attribute.value = null;
  }

  onChange(){
    this.emit({ name: "autosave", data: "silently" })
  }
}
